module.exports = __webpack_public_path__ + "media/images/common/bnr_ticket-fedfac9aebfa356996e0ac2550ec5f81.gif";